export function toggleServiceMore(id) {
    const main = document.querySelector('.services .services__main'),
        foot = document.querySelector('.services .services__foot'),
        currentSlide = document.querySelector(`.services .slider-more__item[data-id='${id}'`),
        currentSlideMore = document.querySelector('.services .slider-more__item.show');

    if (id) {
        main.classList.add('opacity-0');
        foot.classList.add('show');
        currentSlide.classList.add('show');
    } else {
        main.classList.remove('opacity-0');
        currentSlideMore.classList.remove('show');

        setTimeout(() => {
            foot.classList.remove('show');
        }, 100)
    }
}
